/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_CommunityInputs */

const en_gc_resources_faq_community = /** @type {(inputs: Gc_Resources_Faq_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit the ArtCraft community`)
};

const zh_gc_resources_faq_community = /** @type {(inputs: Gc_Resources_Faq_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问 ArtCraft 社区`)
};

/**
* | output |
* | --- |
* | "Visit the ArtCraft community" |
*
* @param {Gc_Resources_Faq_CommunityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_community = /** @type {((inputs?: Gc_Resources_Faq_CommunityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_CommunityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_community(inputs)
	return zh_gc_resources_faq_community(inputs)
});
export { gc_resources_faq_community as "gc.resources.faq.community" }